import './EditSpaceModule.css';

import { NavLink, Navigate, Route, Routes } from "react-router-dom";

import { EditSpacePage } from "../features/spaces/pages/edit-space-page/EditSpacePage";
import { PermissionPage } from "../features/spaces/pages/permissions-page/PermissionsPage";

export function EditSpaceModule() {
  return (

    <div className="edit-content">
        <div className='edit-space-side-bar'>
          Settings
          <NavLink to="space" className="edit-overview">Edit Overview</NavLink>
          <NavLink to="permission" className="edit-permissions">Permissions</NavLink>
        </div>

        <div className="edit-content-page-area">
        <Routes>
            <Route index element={<Navigate to="space" />} />
            <Route path="space" element={<EditSpacePage />} />
            <Route path="permission" element={<PermissionPage />} />
        </Routes>
        </div>

    </div>
  );
}
